import { useLazyQuery, useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react'
import { Card, Form, Spinner, Button } from "react-bootstrap"
import { GET_BANKS } from '../../graphql/bank/query';
import { UPDATE_BANK, UPDATE_BANK_ACTIVE } from '../../graphql/bank/mutation';

export default function BankAccountActive({ onCloseModal, fetchNewDataBank }) {

  // state
  const [shopBankDatas, setShopBankDatas] = useState([])
  const [selectedBank, setSelectedBank] = useState(null);

  // apollo client hooks
  const [getBank, { data: bankDatas, loading: loadingBankDatas }] = useLazyQuery(GET_BANKS, {
    fetchPolicy: "cache-and-network",
  });
  const [updateBankAccount, { loading: loadingUpdate }] = useMutation(UPDATE_BANK_ACTIVE)

  useEffect(() => {
    let shopId = localStorage.getItem("SHOP");
    handleFetchBank(shopId)
  }, [])

  useEffect(() => {
    if (bankDatas) {
      setShopBankDatas(bankDatas?.banks?.data)
    }
  }, [bankDatas])

  const handleFetchBank = async (_shopId) => {
    try {
      if (loadingBankDatas) return;
      await getBank({
        variables: {
          where: {
            shop: _shopId,
            isDeleted: false
          },
          skip: 0,
          limit: 100,
          orderBy: "createdAt_DESC"
        },
      })

    } catch (error) {
      console.error({ error })
    }
  }

  // update bank account setDefault
  const handleSelectAtiveBank = async () => {
    if (!selectedBank) return; // Ensure that a bank is selected

    let shopId = localStorage.getItem("SHOP");
    try {
      if (loadingUpdate) return;
      const response = await updateBankAccount({
        variables: {
          data: {
            isActiveDefault: true
          },
          where: {
            id: selectedBank?.id,
            shop: shopId
          }
        }
      })

      if (response?.data?.updateBankActive) {
        onCloseModal();
        fetchNewDataBank();
      }

    } catch (error) {
      console.log({ error })
    }
  }

  // Handle selecting the active bank
  const handleSelectBank = (item) => {
    setSelectedBank(item);
  }

  return (
    <div>
      <h4 className="mb-4 w-100 text-center">ເລືອກບັນຊີທີ່ຕ້ອງການນຳໃຊ້</h4>

      {/* Loading State */}
      {(loadingBankDatas && !bankDatas) ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" />
        </div>
      ) : (
        shopBankDatas?.map((item, index) => (
          <Card  key={index} style={{ boxShadow: 'none', margin: '5px 0', position: 'relative' }} border={item?.isActiveDefault ? "success" : "secondary"}>
            <Card.Body>
              <Card.Title>{item?.bankUser}</Card.Title>
              <Card.Subtitle>{item?.bankName}</Card.Subtitle>
              <Card.Text>{item?.bankAccount}</Card.Text>

              <div style={{ position: "absolute", top: 20, right: 5 }}>
                <Form.Check
                  inline
                  style={{ transform: "scale(1.8)" }}
                  onChange={() => handleSelectBank(item)}
                  name="group1"
                  type="checkbox"
                  id={`checkbox-${index}`}
                  checked={selectedBank?.id === item?.id} // Check if the current bank is selected
                />
              </div>
            </Card.Body>
          </Card>
        ))
      )}


      <div className='mt-4'>
      <Button
          onClick={onCloseModal}
          variant='light'
        >
          ຍົກເລີກ
        </Button>
        <Button
          onClick={handleSelectAtiveBank}
          disabled={loadingUpdate || !selectedBank} 
          variant='info'
        >
          ບັນທຶກ
        </Button>
      </div>
    </div>
  )
}
